<div [formGroup]="formGroup">
  <tui-input-slider
    [formControlName]="formControlName"
    [max]="max"
    [min]="min"
    [nativeId]="id"
    [pseudoFocus]="focus ?? null"
    [pseudoInvalid]="invalid === undefined ? null : invalid"
    [quantum]="quantum"
    [readOnly]="properties?.readOnly ?? false"
    [steps]="steps"
    [tuiHintContent]="hintContent"
    [tuiTextfieldCleaner]="true"
    [tuiTextfieldIconLeft]="icon"
    [tuiTextfieldPostfix]="postfix"
    [tuiTextfieldPrefix]="prefix"
    [tuiTextfieldSize]="size"
    (focusedChange)="handleFocusedChange($event)"
  >
    {{ label }}
    <span
      class="tui-required"
      *ngIf="validators.required"
    ></span>
  </tui-input-slider>
</div>
